import { Rescatable } from '../Rescatable';
import { order } from '../decorators/order';
import { imagenPathS3 } from '../decorators/imagenPathS3';

export class MainBanner extends Rescatable {
  static _name = 'MainBanner';
  static pathRequest = Rescatable.pathRequestStatic + 'espacios/principales';
  static pk: keyof MainBanner = 'id';
  id: number;
  estado: boolean;
  @imagenPathS3('/bannerPrincipal')
  nombre: string;
  @imagenPathS3('/bannerPrincipal')
  nombreTablet: string;
  @imagenPathS3('/bannerPrincipal')
  nombreMobile: string;
  @imagenPathS3('/bannerPrincipal')
  nombre_xxl: string;
  @imagenPathS3('/bannerPrincipal')
  nombre_xl: string;
  @imagenPathS3('/bannerPrincipal')
  nombre_lg: string;
  @imagenPathS3('/bannerPrincipal')
  nombre_md: string;
  @imagenPathS3('/bannerPrincipal')
  nombre_sm: string;
  @order()
  orden: number;
  descripcion: string;
  link: string;
  ventana: number;
  fechaVencimiento: string;
  fechaLanzamiento: string;
  constructor(mainBanner: MainBanner) {
    super(mainBanner);
  }
}
